import { render, staticRenderFns } from "./pcB.vue?vue&type=template&id=7f517ce5&scoped=true&"
import script from "./pcB.vue?vue&type=script&lang=js&"
export * from "./pcB.vue?vue&type=script&lang=js&"
import style0 from "./pcB.vue?vue&type=style&index=0&id=7f517ce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f517ce5",
  null
  
)

export default component.exports